import { BsPlusCircle, BsDownload, BsMap } from "react-icons/bs"
import { FaUserPlus, FaVideo, FaRegFolderOpen, FaRegTrashAlt } from "react-icons/fa"
import { FiMinusCircle } from "react-icons/fi"
import { RiCheckboxBlankCircleLine, RiCheckboxCircleLine } from "react-icons/ri"
import { IoIosSearch, IoIosArrowRoundBack } from "react-icons/io"

export const icon = {
    BsPlusCircle, 
    BsDownload, 
    BsMap,
    FaUserPlus,
    FaVideo,
    FaRegFolderOpen, 
    FaRegTrashAlt,
    FiMinusCircle,
    RiCheckboxBlankCircleLine, 
    RiCheckboxCircleLine,
    IoIosSearch, 
    IoIosArrowRoundBack
}